import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { DashboardResolverService } from './dashboard-resolver.service';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';
import { DashboardType } from '../enums/DashboardType.enum';

@Injectable()
export class AdvertiserResolver implements Resolve<any> {

    constructor(
        private dashboardResolveService: DashboardResolverService
    ) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.dashboardResolveService.resolveAdvertiser(route);
    }
}

@Injectable()
export class MarketResolver implements Resolve<any> {

    constructor(private dashboardResolveService: DashboardResolverService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.dashboardResolveService.resolveMarket(route);
    }
}

@Injectable()
export class PlannerResolver implements Resolve<any> {

    constructor(private dashboardResolveService: DashboardResolverService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.dashboardResolveService.resolvePlanner(route);
    }
}

@Injectable()
export class PlannerDetailsResolver implements Resolve<any> {

    constructor(private dashboardResolveService: DashboardResolverService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.dashboardResolveService.resolvePlannerDetails(route);
    }
}

@Injectable()
export class PlannerDefaultResolver implements Resolve<any> {

    constructor(private dashboardResolveService: DashboardResolverService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.dashboardResolveService.resolvePlannerDefault(route);
    }
}

@Injectable()
export class InventorySourceResolver implements Resolve<any> {

    constructor(private dashboardResolveService: DashboardResolverService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.dashboardResolveService.resolveCurrentInvSources(route);
    }
}

@Injectable()
export class PlannerResultResolver implements Resolve<any> {

    constructor(private dashboardResolveService: DashboardResolverService) { }

    resolve(route: ActivatedRouteSnapshot) {
        return this.dashboardResolveService.resolvePlannerResult(route);
    }
}

@Injectable()
export class DashboardResolver implements Resolve<any> {

    constructor(
        private dashboardResolveService: DashboardResolverService,
        private breadcrumbService: BreadcrumbService
    ) { }

    resolve(route: ActivatedRouteSnapshot): Promise<any> {
        let dashboardType = route.data.dashboardType,
            resolvedData: Promise<any>;
        switch (dashboardType) {
            case DashboardType.MarketDashboard:
                resolvedData = this.dashboardResolveService.resolveMarket(route);
                break;
            case DashboardType.AdvertiserDashboard:
                resolvedData = this.dashboardResolveService.resolveAdvertiser(route);
                break;
            case DashboardType.PlannerDashboard:
                resolvedData = this.dashboardResolveService.resolvePlannerDetails(route);
                break;
        }
        resolvedData.then((data) => this.breadcrumbService.updateBreadcrumbForDashboard(dashboardType, data));
        return resolvedData;
    }
}
